export const VENUE_CATEGORIES_FETCH_BEGIN = 'syftacp/VENUE_CATEGORIES_FETCH_BEGIN'
export const VENUE_CATEGORIES_FETCH_FAILED = 'syftacp/VENUE_CATEGORIES_FETCH_FAILED'
export const VENUE_CATEGORIES_FETCH_SUCCEEDED = 'syftacp/VENUE_CATEGORIES_FETCH_SUCCEEDED'
